// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const server = {
    domain: 'www.yeshiva.org.il',
    port: '',
    protocol: 'https://',
};

const pic = {
    domain: 'pic.yeshiva.org.il',
    port: '',
    protocol: 'https://',
};

const video = {
    domain: 'video.yeshiva.org.il',
    port: '',
    protocol: 'https://',
};

export const base = {
    server: server,
    pic: pic,
    video: video,
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
